// Shared helpers for interpreting issue flags coming back from both
// legacy (string/boolean) and new (emoji) data exports.
export const DRAIN_PAN_FIELD_NAMES = [
  'drip_pan__sensor',
  'drip_pan_sensor',
  'drip_pan',
  'drain_pan',
  'drain_pan_sensor'
];

const POSITIVE_KEYWORDS = [
  'has issue',
  'has issues',
  'needs service',
  'needs repair',
  'needs replacement',
  'needs attention',
  'repair needed',
  'replacement needed',
  'not working',
  'broken',
  'failed',
  'fail',
  'leak',
  'leaks',
  'leaking',
  'damaged',
  'damage',
  'clog',
  'clogged',
  'dirty',
  'rust',
  'drain pan',
  'drip pan',
  'sensor',
  'standing water',
  'overflow',
  'water damage',
  'mould',
  'mold',
  'bad',
  'issue', // handle legacy values that simply say "Issue"
  '🔴',
  '⚠️'
];

const NEGATIVE_KEYWORDS = [
  'no issues',
  'no issue',
  'no problem',
  'no problems',
  'system fully functional',
  'none',
  'n/a',
  'na',
  'ok',
  'okay',
  'resolved',
  'clear',
  'clean',
  'working',
  'functional',
  'pass',
  'false',
  '0',
  'none observed',
  'none found',
  'no concern',
  'no concerns',
  'no deficiency',
  'no deficiencies',
  '🟢'
];

const hasNegativePhrase = (lowerValue) => {
  if (/no\s+\w*\s+issues?/.test(lowerValue)) return true;
  if (/no\s+\w*\s+problems?/.test(lowerValue)) return true;
  return NEGATIVE_KEYWORDS.some((keyword) => lowerValue.includes(keyword));
};

const hasPositivePhrase = (lowerValue) => {
  return POSITIVE_KEYWORDS.some((keyword) => lowerValue.includes(keyword));
};

export const valueIndicatesIssue = (value) => {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value === null || value === undefined) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some((entry) => valueIndicatesIssue(entry));
  }

  if (typeof value === 'string') {
    const normalized = value.trim();
    if (!normalized) return false;
    const lowerValue = normalized.toLowerCase();

    if (hasNegativePhrase(lowerValue)) {
      return false;
    }

    if (hasPositivePhrase(lowerValue)) {
      return true;
    }

    if (['true', 'yes', '1'].includes(lowerValue)) {
      return true;
    }
    if (['false', 'no', '0'].includes(lowerValue)) {
      return false;
    }

    // Legacy exports sometimes stored the word "Drain Pan" or other descriptions
    // directly inside the field. Treat any remaining descriptive value as an issue.
    return true;
  }

  return Boolean(value);
};

const expandKeys = (keyOrKeys) => {
  const keys = Array.isArray(keyOrKeys) ? keyOrKeys : [keyOrKeys];
  const expanded = [];
  keys.forEach((key) => {
    if (!key) return;
    if (key === 'drip_pan__sensor') {
      expanded.push(...DRAIN_PAN_FIELD_NAMES);
    } else {
      expanded.push(key);
    }
  });
  return Array.from(new Set(expanded));
};

export const rowHasIssue = (row, keyOrKeys) => {
  if (!row || !keyOrKeys) return false;
  const keys = expandKeys(keyOrKeys);
  return keys.some((key) => valueIndicatesIssue(row[key]));
};

